import { TextMessageFieldsFragment, PlainTextMessageInput } from '@anyx/common-graphql';
import { getOriginalUrlFromTrackingLinkNodes } from '@anyx/feature-crm/shared';

import { LineMessageBlockType, PlainTextBlock } from '../../components';

import { plainTextToLexicalState } from './utils';

type PlainTextContent = {
  plainTextMessage: PlainTextMessageInput;
};

type PlainTextAdapter = {
  toGQL: (message: PlainTextBlock) => PlainTextContent;
  toOriginalUrls: (message: PlainTextBlock) => string[];
  toMessageBlock: (content: Pick<TextMessageFieldsFragment, 'text' | 'richText'>) => PlainTextBlock;
};

export const plainTextAdapter: PlainTextAdapter = {
  toGQL: ({ text, richText }) => ({ plainTextMessage: { text, richText } }),
  toOriginalUrls: ({ richText }) => (richText ? getOriginalUrlFromTrackingLinkNodes(richText) : []),
  toMessageBlock: ({ text, richText }) => ({
    text,
    richText: richText || plainTextToLexicalState(text),
    type: LineMessageBlockType.enum.PLAIN_TEXT,
  }),
};
